import { Avatar, Badge } from "antd";
import React, { useEffect, useRef } from "react";
import { IoIosNotifications } from "react-icons/io";
import { useNavigate } from "react-router";

import Person from "../../assets/images/staticImages/person.png";
import styles from "./Header.module.css";

// import { IMG_URL } from "../../config/Apis";
import { roles } from "../../config/roles";
import Storage from "../../utills/AsyncStorage";
// import Box from "../box/Box";
import TextComponent from "../textComponent/TextComponent";
import { AuthMiddleware } from "../../Store/Middlewares/AuthMiddleware";
import { useDispatch, useSelector } from "react-redux";
import dummyImg from "../../assets/images/dummy.png";
import { pusher } from "../../utills/PusherHandler";
import {
  sessionExpired,
  setNotificationCount,
} from "../../Store/Actions/GeneralActions";
import { BiLogOut } from "react-icons/bi";
import { getUser, isLogin } from "../../Store/Actions/AuthAction";
import useWindowDimensions from "../../hooks/useWindowDimensions";
const CompHeader = ({
  onBackClick,
  title,
  collapsed,
  isProfile,
  mainHeader,
}) => {
  const role = Storage.getERole("@role");
  const { width } = useWindowDimensions();

  const navigation = useNavigate();
  const dispatch = useDispatch();
  const channel = useRef(null);
  const notifiCounter = useSelector(
    (state) => state?.GeneralReducer?.unReadNotification,
  );

  const user = useSelector((state) => state.AuthReducer.user);
  // console.log("user/////////////", user);

  // useEffect(() => {
  //   dispatch(AuthMiddleware.getUserData());
  // }, []);

  useEffect(() => {
    const initiateUnreadNotif = () => {
      channel.current = pusher.subscribe(user?.id.toString());
      channel.current?.bind("App\\Events\\UnreadNotificationCount", (data) => {
        dispatch(setNotificationCount(data?.unread_notifications_count));
      });
      // dispatch(NotificationMiddleware.getNotificationCount());
    };
    initiateUnreadNotif();

    return () => {
      if (channel?.current) {
        channel?.current?.unsubscribe();
      }
    };
  }, []);

  const onLogout = () => {
    dispatch(AuthMiddleware.logout()).then((data) => {
      dispatch(getUser(null));
      dispatch(isLogin(false));
      dispatch(sessionExpired(false));
      localStorage.clear();
      navigation("/company-portal");
    });
  };

  return (
    <div className={`${styles.mainHeaderDiv} ${mainHeader}`}>
      <div
        className={styles.welcomeBanner}
        style={{
          backgroundImage: `url(${
            user?.company_details?.logo || "/placeholder.png"
          })`,
        }}
      >
        <div className={styles.overlay}></div>

        <div className={styles.bannerContent}>
          <Avatar
            size={55}
            icon={<img src={user?.profile_picture || dummyImg} />}
          />

          <div>
            <TextComponent
              className={styles.wellcomeHead}
              text="Welcome Back"
            />
            <TextComponent
              className={styles.userName}
              text={(user?.full_name !== "%" && user?.full_name) || "--"}
            />
          </div>
        </div>
      </div>

      {/* <div className={styles.headingDiv}>
        <Avatar
          size={55}
          icon={<img src={user?.profile_picture || dummyImg} />}
        />
        <div>
          <TextComponent
            className={styles.wellcomeHead}
            text={"Welcome Back"}
          />
          <TextComponent className={styles.heading} text={user?.full_name || "--"} />
        </div>
      </div> */}
      <div className="flex-start" style={{ gap: 15, cursor: "pointer" }}>
        {role === roles.company ? (
          <div className="flex-center">
            <img
              src={require("../../assets/images/logo.png")}
              style={{
                width: width > 768 ? "auto" : "50%",
                height: width > 768 ? "80px" : "40px",
                aspectRatio: "auto",
                marginRight: width > 768 ? 10 : 5,
              }}
            />
            <Badge color="var(--light-grey)" onClick={onLogout}>
              <BiLogOut className={styles.notificationIcon} />
            </Badge>
          </div>
        ) : (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => navigation("/notifications")}
          >
            <Badge count={notifiCounter} color="var(--yellow-color)">
              <img
                src={require("../../assets/images/notificationBell.png")}
                className={styles.notificationIcon}
              />
            </Badge>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompHeader;
